const BLOCK_TYPE = {
    HEADER: 'header',
    PARAGRAPH: 'paragraph',
    LIST: 'list',
    IMAGE: 'image',
    EMBED: 'embed'
}

export default BLOCK_TYPE
